// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IDelinquentClaimsSummaryRecordDto } from './IDelinquentClaimsSummaryRecordDto';
import {
    IDelinquentClaimsSummaryRecordDtoFromJSON,
    IDelinquentClaimsSummaryRecordDtoFromJSONTyped,
    IDelinquentClaimsSummaryRecordDtoToJSON,
    IDelinquentClaimsSummaryRecordDtoToJSONTyped,
} from './IDelinquentClaimsSummaryRecordDto';
import type { IReportSummaryGroupDtoDelinquentClaimsSummaryRecordDto } from './IReportSummaryGroupDtoDelinquentClaimsSummaryRecordDto';
import {
    IReportSummaryGroupDtoDelinquentClaimsSummaryRecordDtoFromJSON,
    IReportSummaryGroupDtoDelinquentClaimsSummaryRecordDtoFromJSONTyped,
    IReportSummaryGroupDtoDelinquentClaimsSummaryRecordDtoToJSON,
    IReportSummaryGroupDtoDelinquentClaimsSummaryRecordDtoToJSONTyped,
} from './IReportSummaryGroupDtoDelinquentClaimsSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryDtoDelinquentClaimsSummaryRecordDto
 */
export interface IReportSummaryDtoDelinquentClaimsSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryDtoDelinquentClaimsSummaryRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {Array<IDelinquentClaimsSummaryRecordDto>}
     * @memberof IReportSummaryDtoDelinquentClaimsSummaryRecordDto
     */
    employer_records?: Array<IDelinquentClaimsSummaryRecordDto>;
    /**
     * 
     * @type {Array<IReportSummaryGroupDtoDelinquentClaimsSummaryRecordDto>}
     * @memberof IReportSummaryDtoDelinquentClaimsSummaryRecordDto
     */
    subsidiary_groups?: Array<IReportSummaryGroupDtoDelinquentClaimsSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryDtoDelinquentClaimsSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryDtoDelinquentClaimsSummaryRecordDto(value: object): value is IReportSummaryDtoDelinquentClaimsSummaryRecordDto {
    return true;
}

export function IReportSummaryDtoDelinquentClaimsSummaryRecordDtoFromJSON(json: any): IReportSummaryDtoDelinquentClaimsSummaryRecordDto {
    return IReportSummaryDtoDelinquentClaimsSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryDtoDelinquentClaimsSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryDtoDelinquentClaimsSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'employer_records': json['employer_records'] == null ? undefined : ((json['employer_records'] as Array<any>).map(IDelinquentClaimsSummaryRecordDtoFromJSON)),
        'subsidiary_groups': json['subsidiary_groups'] == null ? undefined : ((json['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoDelinquentClaimsSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryDtoDelinquentClaimsSummaryRecordDtoToJSON(json: any): IReportSummaryDtoDelinquentClaimsSummaryRecordDto {
    return IReportSummaryDtoDelinquentClaimsSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryDtoDelinquentClaimsSummaryRecordDtoToJSONTyped(value?: IReportSummaryDtoDelinquentClaimsSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employer_name': value['employer_name'],
        'employer_records': value['employer_records'] == null ? undefined : ((value['employer_records'] as Array<any>).map(IDelinquentClaimsSummaryRecordDtoToJSON)),
        'subsidiary_groups': value['subsidiary_groups'] == null ? undefined : ((value['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoDelinquentClaimsSummaryRecordDtoToJSON)),
    };
}

